<template>
  <div>
    <c-list
      :data="list.items"
      :columns="cList.columns"
      :total="list.total"
      :page-current="listPageCurrent"
      :search-where="listSearchWhere"
      @selection-change="handleListSelectionChange"
    >
      <c-list-header>
        <c-list-operations>
          <Button type="primary" @click="$refs.form.show()">
            新增
          </Button>
          <c-bulk-delete
            :selected-items="listSelectedItems"
            @ok="confirmDelete"
          >
          </c-bulk-delete>
          <Button @click="$helpers.goBack()">
            返回
          </Button>
        </c-list-operations>
      </c-list-header>
    </c-list>
    <c-list-form ref="form" @get-list="getList"></c-list-form>
    <c-list-df ref="listDk" @get-list="getList"></c-list-df>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import ListForm from "./form";
import ListDk from "./listDk";
import RouteParamsMixin from "view-ui-admin/src/mixins/route-params";
import ListMixin from "view-ui-admin/src/mixins/list";

const module = "courses";
const initWhere = {
  status: {
    $eq: ""
  },
  title: {
    $like: ""
  }
};

@Component({
  mixins: [RouteParamsMixin, ListMixin],
  components: {
    "c-list-form": ListForm,
    "c-list-df": ListDk,
  },
  computed: mapState({
    list: state => state[module].list
  })
})
export default class extends Vue {
  data() {
    return {
      cList: {
        columns: [
          {
            type: "selection",
            width: 60
          },

          {
            title: "上课时间",
            render: (h, { row }) =>
              h("span", null, `${row.date} ${row.startTime}-${row.endTime}`)
          },
          {
            title: "任课老师",
            width: 130,
            render: (h, { row }) => h("span", null, row.teacher.name)
          },
          {
            title: "是否补课",
            width: 130,
            render: (h, { row }) =>
              h(
                "span",
                null,
                this.$helpers.getItem(this.dicts.Is, "value", row.makeUp)[
                  "label"
                ] || ""
              )
          },

          {
            title: "操作",
            key: "action",
            width: 200,
            render: (h, { row }) =>
              [
              h("Button", {
                on: {
                  click: () => {
                    this.openDk(row.id);
                  }
                }
              },"查看打卡"),
              h("c-confirm-button", {
                props: {
                  buttonText: "删除",
                  confirmText: "确认删除？"
                },
                on: {
                  ok: () => {
                    this.confirmDelete(row.id);
                  }
                }
              })
              ]
          }
        ],
        cSearch: {
          where: this.$helpers.deepCopy(initWhere)
        }
      }
    };
  }

  async beforeRouteUpdate(to, from, next) {
    this.initListSearchWhere(initWhere);
    this.getList();
    next();
  }

  async created() {
    this.initListSearchWhere(initWhere);
    this.getList();
  }

  getList() {
    return this.$store.dispatch(`${module}/getList`, {
      query: {
        offset: (this.listPageCurrent - 1) * this.$consts.PageSize,
        limit: this.$consts.PageSize,
        include: [{ model: "Teacher", as: "teacher" }],
        where: {
          ...this.listSearchWhere,
          classId: this.$route.params.classId
        }
      }
    });
  }

  openDk(id) {
    const row = this.list.items.find(i => i['id'] == id);
    if (!row) return;
    this.$refs.listDk.show(row);
  }

  async confirmDelete(ids) {
    await this.$store.dispatch(`${module}/delete`, { id: ids });
    this.$Message.success("删除成功");

    const { items } = await this.getList();
    !items.length && this.goListPrevPage();
  }

  async changeStatus(id, action) {
    await this.$store.dispatch(`${module}/put`, {
      id,
      body: {
        status: action
      }
    });
    this.$Message.success("修改状态成功");
    this.getList();
  }

  async order(id, action) {
    await this.$store.dispatch(`${module}/postAction`, {
      id,
      action: "order",
      query: {
        where: this.listSearchWhere || initWhere
      },
      body: { action }
    });

    this.$Message.success("排序成功");
    this.getList();
  }
}
</script>
